import type { FaireProductEntity } from "../../entity_types/product";

export const p_7btqth67y7: FaireProductEntity = {
  token: "p_7btqth67y7",
  type: "product",
  name: "Blue Leather Embossed Journal with Quartz stone",
  brandToken: "b_6k5xkw1g4n",
  brandName: "Fantasy Gifts",
  imageUrl:
    "https://cdn.faire.com/fastly/026752c24f88e6a1bd172668f79564c70f8ae68b93d310663284f0d5c8002a58.jpeg",
  galleryImageUrls: [],
  priceDollars: 26.33,
  description:
    "Blue Leather Embossed Journal with Quartz stone\n5 x 7 inches with Aged Looking Handmade Linen Parchment Paper",
  tags: [],
  msrpDollars: 52.66,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:47.669Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
